import { useEffect, useState } from "react";

export function OfflineNotice() {
  const [online, setOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div className="offline-notice" role="status" aria-live="polite">
      Looks like you're offline &mdash; connect to the internet to keep budgeting!
    </div>
  );
}
